export const filter = {
    id: "",
    patient_id: "",
    room_id: "",
    total_price: "",
    paid_price: "",
    day: "",
    notes: "",
    condition_id: "",
    partner_doctor_id: "",
    partner_clinic_id: null,
    yes_doctor: "",
    doctor_id: "",
    from_hour: "",
    duration: "",
    search: "",
    created_at: "",
    updated_at: "",
};
